

// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useMemo,
// } from "react";

// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import { API } from "../config";

// import "../../style/ConfiguracionNotas.css";

// export default function ConfiguracionNotas() {
//   const { token, user } = useAuth();

//   /* ======================================================
//       ESTADOS
//   ====================================================== */

//   const [items, setItems] = useState([]);

//   const [rangos, setRangos] = useState([]);

//   const [config, setConfig] = useState({
//     escala_min: 0,
//     escala_max: 100,
//   });

//   const [promocion, setPromocion] = useState({
//     nota_minima_aprobacion: 60,
//     max_materias_perdidas: 0,
//   });

//   const [nuevoItem, setNuevoItem] = useState({
//     nombre_item: "",
//     porcentaje: "",
//   });

//   const [loading, setLoading] = useState(false);

//   const [editMode, setEditMode] = useState(false);

//   /* ======================================================
//       HEADERS
//   ====================================================== */

//   const authHeaders = useMemo(() => {
//     return {
//       Authorization: `Bearer ${token}`,
//       "x-tenant-id": user?.tenant_id,
//     };
//   }, [token, user]);

//   /* ======================================================
//       TOTAL %
//   ====================================================== */

//   const totalPorcentaje = useMemo(() => {
//     return items.reduce((acc, item) => {
//       return acc + Number(item.porcentaje || 0);
//     }, 0);
//   }, [items]);

//   /* ======================================================
//       VALIDAR RANGOS
//   ====================================================== */

//   const validarRangos = () => {
//     if (!rangos.length) {
//       return "Debe agregar mínimo un rango";
//     }

//     for (const r of rangos) {
//       const min = Number(r.nota_min);
//       const max = Number(r.nota_max);

//       if (isNaN(min) || isNaN(max)) {
//         return "Hay rangos inválidos";
//       }

//       if (min > max) {
//         return `El rango "${r.nombre_rango}" tiene valores inválidos`;
//       }

//       if (
//         min < Number(config.escala_min) ||
//         max > Number(config.escala_max)
//       ) {
//         return `El rango "${r.nombre_rango}" está fuera de la escala`;
//       }
//     }

//     return null;
//   };

//   /* ======================================================
//       CARGAR CONFIGURACIONES
//   ====================================================== */

//   const fetchConfiguraciones = useCallback(async () => {
//     if (!token || !user?.tenant_id) return;

//     try {
//       setLoading(true);

//       const [resNotas, resAcademica] = await Promise.all([
//         axios.get(`${API}/configuracion-notas`, {
//           headers: authHeaders,
//         }),

//         axios.get(
//           `${API}/configuracion-notas/configuracion-academica`,
//           {
//             headers: authHeaders,
//           }
//         ),
//       ]);

//       const cfg = resNotas?.data?.config || {};

//       const cfgAcademica =
//         resAcademica?.data?.config || {};

//       /* =========================================
//           ITEMS
//       ========================================= */

//       setItems(
//         Array.isArray(cfg.items)
//           ? cfg.items.map((item, index) => ({
//               id:
//                 item.id ||
//                 `item-${index}`,

//               nombre_item:
//                 item.nombre_item || "",

//               porcentaje: Number(
//                 item.porcentaje || 0
//               ),
//             }))
//           : []
//       );

//       /* =========================================
//           RANGOS
//       ========================================= */

//       if (
//         Array.isArray(cfg.rangos) &&
//         cfg.rangos.length > 0
//       ) {
//         setRangos(
//           cfg.rangos.map((r, index) => ({
//             id:
//               r.id ||
//               `rango-${index}`,

//             nombre_rango:
//               r.nombre_rango || "",

//             desempeno:
//               r.desempeno || "",

//             nota_min: Number(
//               r.nota_min || 0
//             ),

//             nota_max: Number(
//               r.nota_max || 0
//             ),
//           }))
//         );
//       } else {
//         /* =========================================
//             RANGOS DEFAULT COMPATIBLES
//             CON DECIMALES
//         ========================================= */

//         setRangos([
//           {
//             id: "1",
//             nombre_rango: "Bajo",
//             desempeno: "bajo",
//             nota_min: 10,
//             nota_max: 59.9,
//           },
//           {
//             id: "2",
//             nombre_rango: "Básico",
//             desempeno: "basico",
//             nota_min: 60,
//             nota_max: 79.9,
//           },
//           {
//             id: "3",
//             nombre_rango: "Alto",
//             desempeno: "alto",
//             nota_min: 80,
//             nota_max: 89.9,
//           },
//           {
//             id: "4",
//             nombre_rango: "Superior",
//             desempeno: "superior",
//             nota_min: 90,
//             nota_max: 100,
//           },
//         ]);
//       }

//       /* =========================================
//           ESCALA
//       ========================================= */

//       setConfig({
//         escala_min: Number(
//           cfg.escala_min ?? 0
//         ),

//         escala_max: Number(
//           cfg.escala_max ?? 100
//         ),
//       });

//       /* =========================================
//           PROMOCIÓN
//       ========================================= */

//       setPromocion({
//         nota_minima_aprobacion: Number(
//           cfgAcademica?.nota_minima_aprobacion ??
//             60
//         ),

//         max_materias_perdidas: Number(
//           cfgAcademica?.max_materias_perdidas ??
//             0
//         ),
//       });
//     } catch (err) {
//       console.error(
//         "❌ Error cargando configuración:",
//         err
//       );

//       alert(
//         err?.response?.data?.msg ||
//           "Error cargando configuración"
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, [token, user, authHeaders]);

//   useEffect(() => {
//     fetchConfiguraciones();
//   }, [fetchConfiguraciones]);

//   /* ======================================================
//       GUARDAR
//   ====================================================== */

//   const handleGuardar = async () => {
//     try {
//       /* =========================================
//           VALIDAR ESCALA
//       ========================================= */

//       if (
//         Number(config.escala_min) >=
//         Number(config.escala_max)
//       ) {
//         return alert(
//           "La escala mínima debe ser menor a la máxima"
//         );
//       }

//       /* =========================================
//           VALIDAR ITEMS
//       ========================================= */

//       if (!items.length) {
//         return alert(
//           "Debe agregar mínimo un ítem"
//         );
//       }

//       if (
//         Math.abs(totalPorcentaje - 100) >
//         0.01
//       ) {
//         return alert(
//           "La suma total debe ser exactamente 100%"
//         );
//       }

//       /* =========================================
//           VALIDAR RANGOS
//       ========================================= */

//       const errorRangos =
//         validarRangos();

//       if (errorRangos) {
//         return alert(errorRangos);
//       }

//       setLoading(true);

//       /* =========================================
//           PAYLOAD
//       ========================================= */

//       const payloadNotas = {
//         escala_min: Number(
//           config.escala_min
//         ),

//         escala_max: Number(
//           config.escala_max
//         ),

//         items: items.map((item) => ({
//           nombre_item:
//             item.nombre_item.trim(),

//           porcentaje: Number(
//             item.porcentaje
//           ),
//         })),

//         rangos: rangos.map((r) => ({
//           nombre_rango:
//             r.nombre_rango.trim(),

//           desempeno:
//             r.desempeno.trim(),

//           nota_min: parseFloat(
//             r.nota_min
//           ),

//           nota_max: parseFloat(
//             r.nota_max
//           ),
//         })),
//       };

//       const payloadAcademico = {
//         nota_minima_aprobacion:
//           parseFloat(
//             promocion.nota_minima_aprobacion
//           ),

//         max_materias_perdidas:
//           parseInt(
//             promocion.max_materias_perdidas
//           ),

//         promedio_minimo_anual:
//           parseFloat(
//             promocion.nota_minima_aprobacion
//           ),

//         tipo_promocion:
//           "AUTOMATICA",
//       };

//       /* =========================================
//           GUARDAR
//       ========================================= */

//       await axios.post(
//         `${API}/configuracion-notas`,
//         payloadNotas,
//         {
//           headers: authHeaders,
//         }
//       );

//       await axios.post(
//         `${API}/configuracion-notas/configuracion-academica`,
//         payloadAcademico,
//         {
//           headers: authHeaders,
//         }
//       );

//       alert(
//         "✅ Configuración guardada correctamente"
//       );

//       setEditMode(false);

//       fetchConfiguraciones();
//     } catch (err) {
//       console.error(
//         "❌ Error guardando:",
//         err
//       );

//       alert(
//         err?.response?.data?.msg ||
//           "Error guardando configuración"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ======================================================
//       AGREGAR ITEM
//   ====================================================== */

//   const handleAgregarItem = () => {
//     if (
//       !nuevoItem.nombre_item.trim()
//     ) {
//       return alert(
//         "Ingrese el nombre del ítem"
//       );
//     }

//     const porcentaje = parseFloat(
//       nuevoItem.porcentaje
//     );

//     if (
//       isNaN(porcentaje) ||
//       porcentaje <= 0
//     ) {
//       return alert(
//         "Porcentaje inválido"
//       );
//     }

//     if (
//       totalPorcentaje + porcentaje >
//       100
//     ) {
//       return alert(
//         "La suma supera el 100%"
//       );
//     }

//     setItems((prev) => [
//       ...prev,
//       {
//         id: crypto.randomUUID(),

//         nombre_item:
//           nuevoItem.nombre_item.trim(),

//         porcentaje,
//       },
//     ]);

//     setNuevoItem({
//       nombre_item: "",
//       porcentaje: "",
//     });
//   };

//   /* ======================================================
//       AGREGAR RANGO
//   ====================================================== */

//   const handleAgregarRango = () => {
//     setRangos((prev) => [
//       ...prev,
//       {
//         id: crypto.randomUUID(),

//         nombre_rango: "",

//         desempeno: "",

//         nota_min: 0,

//         nota_max: 0,
//       },
//     ]);
//   };

//   /* ======================================================
//       RENDER
//   ====================================================== */

//   return (
//     <div className="config-notas-container">
//       <header className="config-header">
//         <h2>
//           Configuración de Notas
//         </h2>

//         {!editMode ? (
//           <button
//             className="btn-edit"
//             onClick={() =>
//               setEditMode(true)
//             }
//           >
//             Editar Configuración
//           </button>
//         ) : (
//           <button
//             className="btn-cancel"
//             onClick={() => {
//               setEditMode(false);
//               fetchConfiguraciones();
//             }}
//           >
//             Cancelar
//           </button>
//         )}
//       </header>

//       {loading && (
//         <p>Cargando...</p>
//       )}

//       <div
//         className={
//           editMode
//             ? "mode-edit"
//             : "mode-view"
//         }
//       >
//         {/* =========================================
//             ESCALA
//         ========================================= */}

//         <section className="config-card">
//           <h3>
//             Rango de Calificación
//           </h3>

//           <div className="input-group">
//             <label>Mínima:</label>

//             <input
//               type="number"
//               step="0.1"
//               disabled={!editMode}
//               value={
//                 config.escala_min
//               }
//               onChange={(e) =>
//                 setConfig({
//                   ...config,
//                   escala_min:
//                     e.target.value,
//                 })
//               }
//             />

//             <label>Máxima:</label>

//             <input
//               type="number"
//               step="0.1"
//               disabled={!editMode}
//               value={
//                 config.escala_max
//               }
//               onChange={(e) =>
//                 setConfig({
//                   ...config,
//                   escala_max:
//                     e.target.value,
//                 })
//               }
//             />
//           </div>
//         </section>

//         {/* =========================================
//             PROMOCIÓN
//         ========================================= */}

//         <section className="config-card">
//           <h3>
//             Promoción Estudiantil
//           </h3>

//           <div className="input-group">
//             <label>
//               Nota Mínima Aprobación:
//             </label>

//             <input
//               type="number"
//               step="0.1"
//               disabled={!editMode}
//               value={
//                 promocion.nota_minima_aprobacion
//               }
//               onChange={(e) =>
//                 setPromocion({
//                   ...promocion,
//                   nota_minima_aprobacion:
//                     e.target.value,
//                 })
//               }
//             />

//             <label>
//               Materias Perdidas Máx:
//             </label>

//             <input
//               type="number"
//               disabled={!editMode}
//               value={
//                 promocion.max_materias_perdidas
//               }
//               onChange={(e) =>
//                 setPromocion({
//                   ...promocion,
//                   max_materias_perdidas:
//                     e.target.value,
//                 })
//               }
//             />
//           </div>
//         </section>

//         {/* =========================================
//             ITEMS
//         ========================================= */}

//         <section className="config-card">
//           <div className="section-header">
//             <h3>
//               Ítems de Calificación
//             </h3>

//             <strong>
//               Total:
//               {" "}
//               {totalPorcentaje}%
//             </strong>
//           </div>

//           {editMode && (
//             <div className="add-item-bar">
//               <input
//                 placeholder="Nombre ítem"
//                 value={
//                   nuevoItem.nombre_item
//                 }
//                 onChange={(e) =>
//                   setNuevoItem({
//                     ...nuevoItem,
//                     nombre_item:
//                       e.target.value,
//                   })
//                 }
//               />

//               <input
//                 type="number"
//                 step="0.1"
//                 placeholder="%"
//                 value={
//                   nuevoItem.porcentaje
//                 }
//                 onChange={(e) =>
//                   setNuevoItem({
//                     ...nuevoItem,
//                     porcentaje:
//                       e.target.value,
//                   })
//                 }
//               />

//               <button
//                 onClick={
//                   handleAgregarItem
//                 }
//               >
//                 Agregar
//               </button>
//             </div>
//           )}

//           <table className="config-table">
//             <thead>
//               <tr>
//                 <th>Nombre</th>
//                 <th>Porcentaje</th>

//                 {editMode && (
//                   <th>Acción</th>
//                 )}
//               </tr>
//             </thead>

//             <tbody>
//               {items.map((i) => (
//                 <tr key={i.id}>
//                   <td>
//                     {editMode ? (
//                       <input
//                         value={
//                           i.nombre_item
//                         }
//                         onChange={(e) => {
//                           setItems(
//                             (prev) =>
//                               prev.map(
//                                 (
//                                   item
//                                 ) =>
//                                   item.id ===
//                                   i.id
//                                     ? {
//                                         ...item,
//                                         nombre_item:
//                                           e
//                                             .target
//                                             .value,
//                                       }
//                                     : item
//                               )
//                           );
//                         }}
//                       />
//                     ) : (
//                       i.nombre_item
//                     )}
//                   </td>

//                   <td>
//                     {editMode ? (
//                       <input
//                         type="number"
//                         step="0.1"
//                         value={
//                           i.porcentaje
//                         }
//                         onChange={(e) => {
//                           setItems(
//                             (prev) =>
//                               prev.map(
//                                 (
//                                   item
//                                 ) =>
//                                   item.id ===
//                                   i.id
//                                     ? {
//                                         ...item,
//                                         porcentaje:
//                                           e
//                                             .target
//                                             .value,
//                                       }
//                                     : item
//                               )
//                           );
//                         }}
//                       />
//                     ) : (
//                       `${i.porcentaje}%`
//                     )}
//                   </td>

//                   {editMode && (
//                     <td>
//                       <button
//                         onClick={() =>
//                           setItems(
//                             (
//                               prev
//                             ) =>
//                               prev.filter(
//                                 (
//                                   item
//                                 ) =>
//                                   item.id !==
//                                   i.id
//                               )
//                           )
//                         }
//                       >
//                         Eliminar
//                       </button>
//                     </td>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </section>

//         {/* =========================================
//             RANGOS
//         ========================================= */}

//         <section className="config-card">
//           <h3>
//             Rangos de Desempeño
//           </h3>

//           {editMode && (
//             <button
//               onClick={
//                 handleAgregarRango
//               }
//             >
//               + Rango
//             </button>
//           )}

//           <table className="config-table">
//             <thead>
//               <tr>
//                 <th>Nombre</th>
//                 <th>Desempeño</th>
//                 <th>Mín</th>
//                 <th>Máx</th>

//                 {editMode && (
//                   <th>Acción</th>
//                 )}
//               </tr>
//             </thead>

//             <tbody>
//               {rangos.map((r) => (
//                 <tr key={r.id}>
//                   <td>
//                     <input
//                       disabled={!editMode}
//                       value={
//                         r.nombre_rango
//                       }
//                       onChange={(e) => {
//                         setRangos(
//                           (prev) =>
//                             prev.map(
//                               (
//                                 rango
//                               ) =>
//                                 rango.id ===
//                                 r.id
//                                   ? {
//                                       ...rango,
//                                       nombre_rango:
//                                         e
//                                           .target
//                                           .value,
//                                     }
//                                   : rango
//                             )
//                         );
//                       }}
//                     />
//                   </td>

//                   <td>
//                     <input
//                       disabled={!editMode}
//                       value={
//                         r.desempeno
//                       }
//                       onChange={(e) => {
//                         setRangos(
//                           (prev) =>
//                             prev.map(
//                               (
//                                 rango
//                               ) =>
//                                 rango.id ===
//                                 r.id
//                                   ? {
//                                       ...rango,
//                                       desempeno:
//                                         e
//                                           .target
//                                           .value,
//                                     }
//                                   : rango
//                             )
//                         );
//                       }}
//                     />
//                   </td>

//                   <td>
//                     <input
//                       type="number"
//                       step="0.1"
//                       disabled={!editMode}
//                       value={
//                         r.nota_min
//                       }
//                       onChange={(e) => {
//                         setRangos(
//                           (prev) =>
//                             prev.map(
//                               (
//                                 rango
//                               ) =>
//                                 rango.id ===
//                                 r.id
//                                   ? {
//                                       ...rango,
//                                       nota_min:
//                                         e
//                                           .target
//                                           .value,
//                                     }
//                                   : rango
//                             )
//                         );
//                       }}
//                     />
//                   </td>

//                   <td>
//                     <input
//                       type="number"
//                       step="0.1"
//                       disabled={!editMode}
//                       value={
//                         r.nota_max
//                       }
//                       onChange={(e) => {
//                         setRangos(
//                           (prev) =>
//                             prev.map(
//                               (
//                                 rango
//                               ) =>
//                                 rango.id ===
//                                 r.id
//                                   ? {
//                                       ...rango,
//                                       nota_max:
//                                         e
//                                           .target
//                                           .value,
//                                     }
//                                   : rango
//                             )
//                         );
//                       }}
//                     />
//                   </td>

//                   {editMode && (
//                     <td>
//                       <button
//                         onClick={() =>
//                           setRangos(
//                             (
//                               prev
//                             ) =>
//                               prev.filter(
//                                 (
//                                   rango
//                                 ) =>
//                                   rango.id !==
//                                   r.id
//                               )
//                           )
//                         }
//                       >
//                         Eliminar
//                       </button>
//                     </td>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </section>

//         {/* =========================================
//             GUARDAR
//         ========================================= */}

//         {editMode && (
//           <button
//             className="btn-save-main"
//             onClick={
//               handleGuardar
//             }
//             disabled={loading}
//           >
//             {loading
//               ? "Guardando..."
//               : "Guardar Todo"}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }
//

import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";

import axios from "../../api/axiosAuth";

import "../../style/ConfiguracionNotas.css";

export default function ConfiguracionNotas() {

  /* ======================================================
      ESTADOS
  ====================================================== */

  const [items, setItems] = useState([]);

  const [rangos, setRangos] = useState([]);

  const [config, setConfig] = useState({
    escala_min: 0,
    escala_max: 100,
  });

  const [promocion, setPromocion] = useState({
    nota_minima_aprobacion: 60,
    max_materias_perdidas: 0,
  });

  const [nuevoItem, setNuevoItem] = useState({
    nombre_item: "",
    porcentaje: "",
  });

  const [loading, setLoading] = useState(false);

  const [editMode, setEditMode] = useState(false);

  /* ======================================================
      TOTAL %
  ====================================================== */

  const totalPorcentaje = useMemo(() => {
    return items.reduce((acc, item) => {
      return acc + Number(item.porcentaje || 0);
    }, 0);
  }, [items]);

  /* ======================================================
      VALIDAR RANGOS
  ====================================================== */

  const validarRangos = () => {

    if (!rangos.length) {
      return "Debe agregar mínimo un rango";
    }

    for (const r of rangos) {

      const min = Number(r.nota_min);
      const max = Number(r.nota_max);

      if (isNaN(min) || isNaN(max)) {
        return "Hay rangos inválidos";
      }

      if (min > max) {
        return `El rango "${r.nombre_rango}" tiene valores inválidos`;
      }

      if (
        min < Number(config.escala_min) ||
        max > Number(config.escala_max)
      ) {
        return `El rango "${r.nombre_rango}" está fuera de la escala`;
      }
    }

    return null;
  };

  /* ======================================================
      CARGAR CONFIGURACIONES
  ====================================================== */

  const fetchConfiguraciones = useCallback(async () => {

    try {

      setLoading(true);

      const [resNotas, resAcademica] = await Promise.all([
        axios.get("/configuracion-notas"),

        axios.get(
          "/configuracion-notas/configuracion-academica"
        ),
      ]);

      const cfg = resNotas?.data?.config || {};

      const cfgAcademica =
        resAcademica?.data?.config || {};

      /* =========================================
          ITEMS
      ========================================= */

      setItems(
        Array.isArray(cfg.items)
          ? cfg.items.map((item, index) => ({
              id:
                item.id ||
                `item-${index}`,

              nombre_item:
                item.nombre_item || "",

              porcentaje: Number(
                item.porcentaje || 0
              ),
            }))
          : []
      );

      /* =========================================
          RANGOS
      ========================================= */

      if (
        Array.isArray(cfg.rangos) &&
        cfg.rangos.length > 0
      ) {

        setRangos(
          cfg.rangos.map((r, index) => ({
            id:
              r.id ||
              `rango-${index}`,

            nombre_rango:
              r.nombre_rango || "",

            desempeno:
              r.desempeno || "",

            nota_min: Number(
              r.nota_min || 0
            ),

            nota_max: Number(
              r.nota_max || 0
            ),
          }))
        );

      } else {

        /* =========================================
            RANGOS DEFAULT
        ========================================= */

        setRangos([
          {
            id: "1",
            nombre_rango: "Bajo",
            desempeno: "bajo",
            nota_min: 10,
            nota_max: 59.9,
          },
          {
            id: "2",
            nombre_rango: "Básico",
            desempeno: "basico",
            nota_min: 60,
            nota_max: 79.9,
          },
          {
            id: "3",
            nombre_rango: "Alto",
            desempeno: "alto",
            nota_min: 80,
            nota_max: 89.9,
          },
          {
            id: "4",
            nombre_rango: "Superior",
            desempeno: "superior",
            nota_min: 90,
            nota_max: 100,
          },
        ]);
      }

      /* =========================================
          ESCALA
      ========================================= */

      setConfig({
        escala_min: Number(
          cfg.escala_min ?? 0
        ),

        escala_max: Number(
          cfg.escala_max ?? 100
        ),
      });

      /* =========================================
          PROMOCIÓN
      ========================================= */

      setPromocion({
        nota_minima_aprobacion: Number(
          cfgAcademica?.nota_minima_aprobacion ??
          60
        ),

        max_materias_perdidas: Number(
          cfgAcademica?.max_materias_perdidas ??
          0
        ),
      });

    } catch (err) {

      console.error(
        "❌ Error cargando configuración:",
        err
      );

      alert(
        err?.response?.data?.msg ||
        err?.response?.data?.message ||
        "Error cargando configuración"
      );

    } finally {

      setLoading(false);
    }

  }, []);

  useEffect(() => {
    fetchConfiguraciones();
  }, [fetchConfiguraciones]);

  /* ======================================================
      GUARDAR
  ====================================================== */

  const handleGuardar = async () => {

    try {

      /* =========================================
          VALIDAR ESCALA
      ========================================= */

      if (
        Number(config.escala_min) >=
        Number(config.escala_max)
      ) {
        return alert(
          "La escala mínima debe ser menor a la máxima"
        );
      }

      /* =========================================
          VALIDAR ITEMS
      ========================================= */

      if (!items.length) {
        return alert(
          "Debe agregar mínimo un ítem"
        );
      }

      if (
        Math.abs(totalPorcentaje - 100) > 0.01
      ) {
        return alert(
          "La suma total debe ser exactamente 100%"
        );
      }

      /* =========================================
          VALIDAR RANGOS
      ========================================= */

      const errorRangos =
        validarRangos();

      if (errorRangos) {
        return alert(errorRangos);
      }

      setLoading(true);

      /* =========================================
          PAYLOAD NOTAS
      ========================================= */

      const payloadNotas = {

        escala_min: Number(
          config.escala_min
        ),

        escala_max: Number(
          config.escala_max
        ),

        items: items.map((item) => ({
          nombre_item:
            item.nombre_item.trim(),

          porcentaje: Number(
            item.porcentaje
          ),
        })),

        rangos: rangos.map((r) => ({
          nombre_rango:
            r.nombre_rango.trim(),

          desempeno:
            r.desempeno.trim(),

          nota_min: parseFloat(
            r.nota_min
          ),

          nota_max: parseFloat(
            r.nota_max
          ),
        })),
      };

      /* =========================================
          PAYLOAD ACADÉMICO
      ========================================= */

      const payloadAcademico = {

        nota_minima_aprobacion:
          parseFloat(
            promocion.nota_minima_aprobacion
          ),

        max_materias_perdidas:
          parseInt(
            promocion.max_materias_perdidas
          ),

        promedio_minimo_anual:
          parseFloat(
            promocion.nota_minima_aprobacion
          ),

        tipo_promocion:
          "AUTOMATICA",
      };

      /* =========================================
          GUARDAR
      ========================================= */

      await axios.post(
        "/configuracion-notas",
        payloadNotas
      );

      await axios.post(
        "/configuracion-notas/configuracion-academica",
        payloadAcademico
      );

      alert(
        "✅ Configuración guardada correctamente"
      );

      setEditMode(false);

      fetchConfiguraciones();

    } catch (err) {

      console.error(
        "❌ Error guardando:",
        err
      );

      console.error(
        "❌ ERROR BACKEND:",
        err?.response?.data
      );

      alert(
        err?.response?.data?.msg ||
        err?.response?.data?.message ||
        "Error guardando configuración"
      );

    } finally {

      setLoading(false);
    }
  };

  /* ======================================================
      AGREGAR ITEM
  ====================================================== */

  const handleAgregarItem = () => {

    if (
      !nuevoItem.nombre_item.trim()
    ) {
      return alert(
        "Ingrese el nombre del ítem"
      );
    }

    const porcentaje = parseFloat(
      nuevoItem.porcentaje
    );

    if (
      isNaN(porcentaje) ||
      porcentaje <= 0
    ) {
      return alert(
        "Porcentaje inválido"
      );
    }

    if (
      totalPorcentaje + porcentaje > 100
    ) {
      return alert(
        "La suma supera el 100%"
      );
    }

    setItems((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),

        nombre_item:
          nuevoItem.nombre_item.trim(),

        porcentaje,
      },
    ]);

    setNuevoItem({
      nombre_item: "",
      porcentaje: "",
    });
  };

  /* ======================================================
      AGREGAR RANGO
  ====================================================== */

  const handleAgregarRango = () => {

    setRangos((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),

        nombre_rango: "",

        desempeno: "",

        nota_min: 0,

        nota_max: 0,
      },
    ]);
  };

  /* ======================================================
      RENDER
  ====================================================== */

  return (
    <div className="config-notas-container">

      <header className="config-header">

        <h2>
          Configuración de Notas
        </h2>

        {!editMode ? (
          <button
            className="btn-edit"
            onClick={() =>
              setEditMode(true)
            }
          >
            Editar Configuración
          </button>
        ) : (
          <button
            className="btn-cancel"
            onClick={() => {
              setEditMode(false);
              fetchConfiguraciones();
            }}
          >
            Cancelar
          </button>
        )}

      </header>

      {loading && (
        <p>Cargando...</p>
      )}

      <div
        className={
          editMode
            ? "mode-edit"
            : "mode-view"
        }
      >

        {/* =========================================
            ESCALA
        ========================================= */}

        <section className="config-card">

          <h3>
            Rango de Calificación
          </h3>

          <div className="input-group">

            <label>Mínima:</label>

            <input
              type="number"
              step="0.1"
              disabled={!editMode}
              value={config.escala_min}
              onChange={(e) =>
                setConfig({
                  ...config,
                  escala_min:
                    e.target.value,
                })
              }
            />

            <label>Máxima:</label>

            <input
              type="number"
              step="0.1"
              disabled={!editMode}
              value={config.escala_max}
              onChange={(e) =>
                setConfig({
                  ...config,
                  escala_max:
                    e.target.value,
                })
              }
            />

          </div>

        </section>

        {/* =========================================
            PROMOCIÓN
        ========================================= */}

        <section className="config-card">

          <h3>
            Promoción Estudiantil
          </h3>

          <div className="input-group">

            <label>
              Nota Mínima Aprobación:
            </label>

            <input
              type="number"
              step="0.1"
              disabled={!editMode}
              value={
                promocion.nota_minima_aprobacion
              }
              onChange={(e) =>
                setPromocion({
                  ...promocion,
                  nota_minima_aprobacion:
                    e.target.value,
                })
              }
            />

            <label>
              Materias Perdidas Máx:
            </label>

            <input
              type="number"
              disabled={!editMode}
              value={
                promocion.max_materias_perdidas
              }
              onChange={(e) =>
                setPromocion({
                  ...promocion,
                  max_materias_perdidas:
                    e.target.value,
                })
              }
            />

          </div>

        </section>

      </div>

      {/* =========================================
          ITEMS
      ========================================= */}

      <section className="config-card">

        <div className="section-header">

          <h3>
            Ítems de Calificación
          </h3>

          <strong>
            Total: {totalPorcentaje}%
          </strong>

        </div>

        {editMode && (

          <div className="add-item-bar">

            <input
              placeholder="Nombre ítem"
              value={
                nuevoItem.nombre_item
              }
              onChange={(e) =>
                setNuevoItem({
                  ...nuevoItem,
                  nombre_item:
                    e.target.value,
                })
              }
            />

            <input
              type="number"
              step="0.1"
              placeholder="%"
              value={
                nuevoItem.porcentaje
              }
              onChange={(e) =>
                setNuevoItem({
                  ...nuevoItem,
                  porcentaje:
                    e.target.value,
                })
              }
            />

            <button
              onClick={
                handleAgregarItem
              }
            >
              Agregar
            </button>

          </div>
        )}

        <table className="config-table">

          <thead>
            <tr>
              <th>Nombre</th>
              <th>Porcentaje</th>

              {editMode && (
                <th>Acción</th>
              )}
            </tr>
          </thead>

          <tbody>

            {items.map((i) => (

              <tr key={i.id}>

                <td>

                  {editMode ? (

                    <input
                      value={
                        i.nombre_item
                      }
                      onChange={(e) => {
                        setItems(
                          (prev) =>
                            prev.map(
                              (item) =>
                                item.id === i.id
                                  ? {
                                      ...item,
                                      nombre_item:
                                        e.target.value,
                                    }
                                  : item
                            )
                        );
                      }}
                    />

                  ) : (
                    i.nombre_item
                  )}

                </td>

                <td>

                  {editMode ? (

                    <input
                      type="number"
                      step="0.1"
                      value={
                        i.porcentaje
                      }
                      onChange={(e) => {
                        setItems(
                          (prev) =>
                            prev.map(
                              (item) =>
                                item.id === i.id
                                  ? {
                                      ...item,
                                      porcentaje:
                                        e.target.value,
                                    }
                                  : item
                            )
                        );
                      }}
                    />

                  ) : (
                    `${i.porcentaje}%`
                  )}

                </td>

                {editMode && (

                  <td>

                    <button
                      onClick={() =>
                        setItems(
                          (prev) =>
                            prev.filter(
                              (item) =>
                                item.id !== i.id
                            )
                        )
                      }
                    >
                      Eliminar
                    </button>

                  </td>

                )}

              </tr>

            ))}

          </tbody>

        </table>

      </section>

      {/* =========================================
          RANGOS
      ========================================= */}

      <section className="config-card">

        <h3>
          Rangos de Desempeño
        </h3>

        {editMode && (
          <button
            onClick={
              handleAgregarRango
            }
          >
            + Rango
          </button>
        )}

        <table className="config-table">

          <thead>

            <tr>
              <th>Nombre</th>
              <th>Desempeño</th>
              <th>Mín</th>
              <th>Máx</th>

              {editMode && (
                <th>Acción</th>
              )}
            </tr>

          </thead>

          <tbody>

            {rangos.map((r) => (

              <tr key={r.id}>

                <td>

                  <input
                    disabled={!editMode}
                    value={
                      r.nombre_rango
                    }
                    onChange={(e) => {
                      setRangos(
                        (prev) =>
                          prev.map(
                            (rango) =>
                              rango.id === r.id
                                ? {
                                    ...rango,
                                    nombre_rango:
                                      e.target.value,
                                  }
                                : rango
                          )
                      );
                    }}
                  />

                </td>

                <td>

                  <input
                    disabled={!editMode}
                    value={
                      r.desempeno
                    }
                    onChange={(e) => {
                      setRangos(
                        (prev) =>
                          prev.map(
                            (rango) =>
                              rango.id === r.id
                                ? {
                                    ...rango,
                                    desempeno:
                                      e.target.value,
                                  }
                                : rango
                          )
                      );
                    }}
                  />

                </td>

                <td>

                  <input
                    type="number"
                    step="0.1"
                    disabled={!editMode}
                    value={
                      r.nota_min
                    }
                    onChange={(e) => {
                      setRangos(
                        (prev) =>
                          prev.map(
                            (rango) =>
                              rango.id === r.id
                                ? {
                                    ...rango,
                                    nota_min:
                                      e.target.value,
                                  }
                                : rango
                          )
                      );
                    }}
                  />

                </td>

                <td>

                  <input
                    type="number"
                    step="0.1"
                    disabled={!editMode}
                    value={
                      r.nota_max
                    }
                    onChange={(e) => {
                      setRangos(
                        (prev) =>
                          prev.map(
                            (rango) =>
                              rango.id === r.id
                                ? {
                                    ...rango,
                                    nota_max:
                                      e.target.value,
                                  }
                                : rango
                          )
                      );
                    }}
                  />

                </td>

                {editMode && (

                  <td>

                    <button
                      onClick={() =>
                        setRangos(
                          (prev) =>
                            prev.filter(
                              (rango) =>
                                rango.id !== r.id
                            )
                        )
                      }
                    >
                      Eliminar
                    </button>

                  </td>

                )}

              </tr>

            ))}

          </tbody>

        </table>

      </section>

      {/* =========================================
          GUARDAR
      ========================================= */}

      {editMode && (

        <button
          className="btn-save-main"
          onClick={
            handleGuardar
          }
          disabled={loading}
        >
          {loading
            ? "Guardando..."
            : "Guardar Todo"}
        </button>

      )}

    </div>
  );
}